import { CardState } from '@witkac/kartamiejska-shared';

import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'card',
  type: 'object',
  properties: {
    state: {
      type: 'string',
      title: 'Status karty *',
      fieldRequired: true
    },
    profileId: {
      type: 'number',
      title: 'Użytkownik karty *',
      fieldRequired: true
    },
    startDate: {
      type: 'string',
      title: 'Ważna od *',
      format: 'date',
      fieldRequired: true
    },
    blockEndDate: {
      type: 'string',
      title: 'Zablokowana do',
      format: 'date',
      fieldRequired: false
    },
    expirationType: {
      type: 'string',
      title: 'Okres ważności karty *',
      fieldRequired: true
    },
    blockReason: {
      type: 'string',
      title: 'Powód blokady karty'
    },
    inactiveReason: {
      type: 'string',
      title: 'Powód dezaktywacji karty'
    },
    duplicate: {
      type: 'boolean',
      title: 'Karta jest duplikatem'
    }
  }
};
